<template>
  <ac-template :menu="menu" :options="options" theme="dark"></ac-template>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'app',
  data: () => ({
    menu: [
      {
        icon: 'fiber_pin',
        label: 'Pins',
        route: { name: 'Pins' },
        roles: ['admin', 'developer', 'support'],
      },
    ],
  }),
  computed: {
    options() {
      return [
        {
          icon: 'power_settings_new',
          label: 'Logout',
          action: this.logout,
          roles: [],
        },
      ];
    },
  },
  created() {
    if (this.$route.query.redirect) this.$router.replace({ path: this.$route.query.redirect });
  },
  methods: {
    ...mapActions(['logout']),
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue